import {Injectable} from '@angular/core';
import {BaseApiService} from '../../base-service/base-api.service';
import {SystemNotificationModel} from '../../models/notification/system-notification.model';
import {SystemNotificationValidationResourceModel} from '../../models/notification/system-notification-validation-resource.model';

@Injectable()
export class SystemNotificationService extends BaseApiService {
    dispatchSystemNotificationModel(model: SystemNotificationModel) {
        return this.post('Foundation/Notification/DispatchSystemNotification/', model);
    }

    dispatchSystemNotification(deliveryChannelTypeIds: number[], userLoginIds: number[], messageText: string, redirectUrl: string = null, expiration = null, customerLoginIds: number[] = null) {
        const message = new SystemNotificationModel();
        message.deliveryChannelTypeIds = deliveryChannelTypeIds;
        message.userLoginIds = userLoginIds;
        message.message.messageText = messageText;
        message.message.redirectUrl = redirectUrl;
        message.message.expirationDate = expiration;
        message.customerNumberIds = customerLoginIds;

        return this.post('Foundation/Notification/DispatchSystemNotification/', message);
    }

    dispatchSystemNotificationValidationResource(model: SystemNotificationValidationResourceModel) {
        return this.post('Foundation/Notification/Dispatch/', model);
    }
}
